import { ConfigProvider } from 'antd';

// antd 4 has no token theme: the variable stylesheet (antd.variable.min.css) plus this call
// recolours every component that derives from the primary colour. Everything else
// (heights, radii, shadows, the orange call to action) lives in shadcn.css.
export const palette = {
  brand: '#1e293b',
  cta: '#f97316',
  success: '#22c55e',
  warning: '#f97316',
  danger: '#ef4444',
};

export const applyAntdTheme = () => {
  ConfigProvider.config({
    theme: {
      primaryColor: palette.brand,
      infoColor: palette.brand,
      processingColor: palette.brand,
      successColor: palette.success,
      warningColor: palette.warning,
      errorColor: palette.danger,
    },
  });
};
